import React from 'react';

import useCurrentUser from 'dpl/common/hooks/useCurrentUser';

export default function StripeChargeModalHeaderLogOut() {
  const user = useCurrentUser();
  const userEmail = user.value?.data?.email;

  function handleLogout() {
    user.logout().then(() => {
      window.location.reload();
    });
  }

  if (!user.isLoggedIn) return null;

  return (
    <div className="f2">
      <span className="fw-medium black o-50">{userEmail} </span>
      <button
        className="purple fw-medium s"
        type="button"
        onClick={handleLogout}
      >
        Log out
      </button>
    </div>
  );
}
